<template>
<v-card class="custom-dailog video-popup">
    <v-card-title>
        {{title}}
        <i class="fas fa-times"
           data-qe-id="close_video_carouse_btn"
           @click="closeVideoCarousel()">
        </i>
    </v-card-title>
    <v-card-text class="video-popup__video-block">
        <v-layout row wrap>
            <v-flex xs12 class="video-popup__main">
                <div class="video-block">
                    <video autoplay controls width="100%" height="100%" :src="takeTourPreviewVideo[0].url" type="video/mp4"></video>
                </div>
                <!--//TODO: commenting out for this release - will add later as the 'title' needs to dynamically change with video-->
              <!--  <v-carousel height="auto" :cycle="false" hide-delimiters>
                    <v-carousel-item v-for="(takeTour,i) in takeTourNavPreviewVideo" :key="i">
                        <v-flex class="video-block">
                            <video autoplay controls width="100%" height="100%" :src="takeTour.url" type="video/mp4"></video>
                        </v-flex>
                    </v-carousel-item>
                </v-carousel>-->
            </v-flex>
        </v-layout>
    </v-card-text>
</v-card>
</template>

<script>
import { WelcomeConstants } from "../AssistPage/AssistPageConstants";

export default {
    name: "VideoCarousel",
    created() {
        this.takeTourNavPreviewVideo = [...this.takeTourPreviewVideo];
        this.title = this.takeTourTitle;
    },
    components: {},
    data: () => ({
        WelcomeConstants,
        takeTourNavPreviewVideo: [],
        title: "",
    }),
    props: {
        openVideo: {
            type: Object,
            default: () => ({}),
        },
        takeTourVideos: {
            type: Array,
            required: true,
        },
        takeTourPreviewVideo: {
            type: Array,
            required: true,
        },
        takeTourTitle: {
            type: String,
            required: true,
        },
    },
    computed: {},
    methods: {
        closeVideoCarousel() {
            this.openVideo.openVideoCarousel = false;
        },
        navigateVideoCarousel(takeTour, index) {
            this.title = takeTour.title;
            this.takeTourNavPreviewVideo = [];
            this.takeTourNavPreviewVideo.push(takeTour);
            const tourLength = this.takeTourVideos.length - 1;
            if (tourLength > index) {
                for (let i = index + 1; i <= tourLength; i++) {
                    this.takeTourNavPreviewVideo.push(this.takeTourVideos[i]);
                }
            }
            for (let i = 0; i < index; i++) {
                this.takeTourNavPreviewVideo.push(this.takeTourVideos[i]);
            }
        },
    },
};
</script>

<style lang="scss">
@import "../../common/styles/_colors.scss";
@import "../../common/styles/responsive.scss";

.video-popup {
    &__video-block {
        max-height: 100vh;
        overflow: hidden !important;
        margin-right: 0 !important;
    }

    &__main {
        .v-carousel__prev, .v-carousel__next {
            background: $ypo-cta;
            .v-icon {
                font-size: 30px !important;
                padding: 1px 10px;
            }
        }
    }

    &__thumb {
        margin-bottom: 10px;

        &__container {
            overflow-y: auto;
            max-height: 77vh;
            padding-right: 10px;
            margin-right: 0 !important;
        }
        &__block {
            position: relative;
            &:after {
            content: "\f144";
            position: absolute;
            font-family: "Font Awesome 5 Free";
            font-size: 34px;
            color: rgba($white, 0.9);
            z-index: 11;
            left: 0;
            right: 0;
            top: 0;
            cursor: pointer;
            height: 100%;
            align-items: center;
            display: flex;
            justify-content: center;
            align-content: center;
            background: rgba($ypo-blue, 0.4);
          }
        }
    }
    @include breakpoint(xs) {
         &__main {
            .v-carousel__prev, .v-carousel__next {
            display: none;
            
        }
    }
        &__thumb {
            margin-bottom: 0px;
            max-width: 50%;
            display: inline-block;
            &__container {
                margin-top: 20px;
            }
            &__block {
                margin: 2px;
                &:after {
                    font-size: 24px;
                }
            }
        }
    }
}
</style>
